import React, { useEffect, useState } from 'react';
import { CustomTextInput } from '../components/CustomTextInput';
import ButtonComponent from '../components/ButtonComponent';
import { assignLockerToPickUpUser, CreateParcelOwner, openLocker, searchParcelOwner } from '../api/api'; 
import CustomDialog from '../components/CustomDialog';
import { LOCAL_STORAGE, LS_DOMAIN_AND_LOCKER_BANK, LS_LOCKER_BANK_INFO, LS_PHONE_NUMBER_LENGTH, LS_PHONE_PREFIX, LS_PROP_LOCKER_UNIT_DETAILS, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS } from '../assets/constants/BrowserStorageKeys';
import { getSecureItemFromSpecificStorage, storeSecureItemInSpecifiedStorage } from '../lib/BrowserStorageAccessMiddleware';
import { AT_SYMBOL, BUTTON_PRIMARY, BUTTON_SECONDARY, BUTTON_WARNING, NOT_OPENED, PENDING, REGEXP_DASH, REGEXP_NUMERIC } from '../assets/constants/Constants';
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CircularProgressLoader from '../components/CircularProgressLoader';
import { CustomSwitchInput } from '../components/CustomSwitchInput';
import ShowToast from "../components/ToastComponent";
import { toast } from 'react-toastify';
import { TOAST_ERROR, TOAST_SUCCESS, TOAST_WARN } from '../assets/constants/Constants';
import { getPathForNextPage, getUnitLabelParams } from '../lib/Utils';
import { DROP_PARCEL, LOCKER_SIZE_SELECTION, LOCKER_UNIT_SELECTION, PARCEL_OWNER } from '../assets/constants/PageList';


function ParcelOwner(props) {
    const [searchValue, setSearchValue] = useState("");
    const [users, setUsers] = useState([]);
    const [isDialogVisible, setIsDialogVisible] = useState(false); 
    const [dialogMessage, setDialogMessage] = useState(""); 
    const [assignmentSlug, setAssignmentSlug] = useState(null);
    const [assignmentSettings, setAssignmentSettings] = useState(null);
    const ShowPickupCompanyName = assignmentSettings?.usecase_settings?.show_pickup_company_name?.value || false;
    const ShowPickupUserName = assignmentSettings?.usecase_settings?.show_pickup_user_name?.value || false;
    const ShowPickupFlat = assignmentSettings?.usecase_settings?.show_pickup_flat?.value || false;
    const ShowPickupManager = assignmentSettings?.usecase_settings?.show_pickup_manager?.value || false;
    const ShowPickupEmail = assignmentSettings?.usecase_settings?.show_pickup_email?.value || false;
    const ShowPickupMobileNo = assignmentSettings?.usecase_settings?.show_pickup_mobile_no?.value || false;
    const [errorMessage, setErrorMessage] = useState("");
    const [disabled, setDisabled] = useState(false);
    const [hasSwitchedAuthMethod, setHasSwitchedAuthMethod] = useState(false);
    const [selCountryLength, setSelCountryLength] = useState(0)
    const lockerBank = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_DOMAIN_AND_LOCKER_BANK);
    const lockerBankId = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_DOMAIN_AND_LOCKER_BANK)?.lockerBankId;
    const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
    const isRandomSelectionEnabled = assignmentSettings?.usecase_settings?.random_selection_of_locker?.value || false;
    const history = useHistory();
    const {lockerSize,lockerItem} =  history.location?.state;
    const [showLoader, setShowLoader] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');
    const { t } = useTranslation();
    const unitLabelParams = getUnitLabelParams(lockerBankInfo?.LockerBankType, t);
    const [mobile, setMobile] = useState("");
    const [email, setEmail] = useState("");
    const [isCreateUserModalVisible, setIsCreateUserModalVisible] = useState(false);
    const [isMobileFieldVisible, setIsMobileFieldVisible] = useState(true);
    const [isEmailFieldVisible, setIsEmailFieldVisible] = useState(false);
    const [createUserInput, setCreateUserInput] = useState("");
    const anonymous_user = assignmentSettings?.usecase_settings?.allow_anonymous_drop_pwa?.value;
    const[anonymousUserFieldValue, setAnonymousUserFieldValue] = useState("");
    const[modelTitle, setModelTitle] = useState(t("infoSearchInformation"));
    const[modelCancelButtonText, setModelCancelButtonText] = useState(t("button_cancel"));
    const[modelConfirmButtonText, setModelConfirmButtonText] = useState(t("button_create_user"));
    const [isBlockedUser, setIsBlockedUser] = useState(false);
    const guest_allowed = assignmentSettings?.usecase_settings?.guest_allowed?.value;
    let phonePrefix = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_PHONE_PREFIX);
    let phonelength = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_PHONE_NUMBER_LENGTH);
    
    useEffect(() => {
        const settings = getSecureItemFromSpecificStorage(LOCAL_STORAGE,LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS);
        if (settings) {
            setAssignmentSettings(settings); 
        }
        if (settings?.slug) {
            setAssignmentSlug(settings.slug);
        } 
    }, []);

    /*
    1) if show_custome_switch_fild is active then
        1) split by spaces, remove empties
        2) safely get second word, remove '-' if present
        3) if user clears input or types less than 3 chars, reset users
    2)else
        1) set all input data into searchuser 
    */
    const handleInputChange = (inputOrEvent, countryData) => {
        let inputValue = "";
        if (anonymous_user) {
            if (typeof inputOrEvent === "string") {
            inputValue = inputOrEvent.trim();
            } else if (typeof inputOrEvent === "number") {
            inputValue = String(inputOrEvent).trim();
            } else if (inputOrEvent?.target?.value) {
            inputValue = inputOrEvent.target.value.trim();
            }
            setAnonymousUserFieldValue(inputValue);
            setSearchValue(inputValue);
        } 
        else {
            if (inputOrEvent?.target?.value) {
                inputValue = inputOrEvent.target.value.trim();
                setSearchValue(inputValue);
            }
        }
        if (!inputValue || inputValue.length < 3) {
            setUsers([]);
            
        }
    };

    const handleSearchUser = async (e) => {
        if(anonymous_user){
            if(searchValue.length < 8){
                ShowToast(t('warning_msg_enter_valid_mobile'), TOAST_WARN);
                setUsers([]);
                return;
            }else if(searchValue.length >= 8){
                setDialogMessage(`${t('warning_msg_ConfirmPickUpNumber')} ${searchValue}`);
                setModelTitle(t('confirm_Text'));
                setModelConfirmButtonText(t('submit_btn'));
                setIsDialogVisible(true);
            }
        }
        if ( !anonymous_user) {
            if((searchValue.length < 3)){
                setUsers([]);
                ShowToast(t('warningEnterAtLeast3Characters'), TOAST_WARN);
                return;
            }
            else{
                SearchUserApiCall();
            }
            
        }
    };

    const SearchUserApiCall = async()=>{
         try {
            const data = await searchParcelOwner(assignmentSlug, searchValue);
            if (data?.data?.length > 0) {
                setUsers(data.data);
            }
            else {
                setUsers([]);
                if(searchValue.includes(AT_SYMBOL)){
                    setIsMobileFieldVisible(false);
                    setIsEmailFieldVisible(true);
                }else{
                    const isValidMobile = REGEXP_NUMERIC.test(searchValue);
                    if(isValidMobile){
                         // if prefix not present and length not there
                            if(phonelength){
                                if(searchValue.length > phonelength){
                                ShowToast(t('warning_msg_enter_valid_mobile'), TOAST_WARN);
                                setUsers([]);
                                return;
                                }
                                else{
                                    setIsMobileFieldVisible(true);
                                    setIsEmailFieldVisible(false);
                                }
                            }
                    }else{
                        setIsMobileFieldVisible(true);
                        setIsEmailFieldVisible(false);
                    }
                    
                }
                setDialogMessage(t('errorNoUsersFound'));
                setIsDialogVisible(true);
            }
        }
        catch (error) {
            setUsers([]);
            ShowToast(t('errorSomethingWentWrong'), TOAST_ERROR);
        }
    }

    const UserInfo = ({ user }) => {
        const username = user.username;
        const fullName = `${user.first_name || ""} ${user.last_name || ""}`.trim() || "";
        const firstChar = username.charAt(0).toUpperCase();
        const info = [];
        info.push(` ${fullName}`);
        if (user.username && ShowPickupUserName ) info.push(`${user.username}`);
        if (user.flat && ShowPickupFlat) info.push(` ${user.flat}`);
        if (user.user_company && ShowPickupCompanyName) info.push(` ${user.user_company}`);
        if (user.manager_name && ShowPickupManager ) info.push(`${user.manager_name}`);
        if (user.email && ShowPickupEmail) info.push(`${user.email}`);
        if (user.mobile_number && ShowPickupMobileNo) info.push(`${user.mobile_number}`);

        return (
            <div className={`user-card ${user.is_active ? "user-card-disabled" : ""}`}>
                <div className="user-avatar">{firstChar}</div>
                    <div className="user-details">
                        <ul className="user-info-list">
                            {info.map((item, index) => (
                                <li key={index} className="user-info-item">
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
            </div>
        );
    };
    const OpenLocker = async(lockerItem)=>{
        const openLockerResponse = await openLocker(lockerItem?.transaction_id);
        if(openLockerResponse?.data && openLockerResponse?.data?.status == "success"){
        }
    }
    const handleAssignLockerToPickUpUser = async (userData) => {
        const {id,email,first_name,mobile_number,last_name,username} = userData;
        setLoadingMessage(t('lockerAssignText', unitLabelParams));
        setShowLoader(true);
        const pickupUserDetails = {
            id,
            first_name,
            last_name,
            email,
            mobile_number,
            username,
        };
        if (isRandomSelectionEnabled) {
            try{
                const responseData =  await assignLockerToPickUpUser( assignmentSlug, lockerBankId, id, lockerSize );
                if(responseData.message === "Success"){
                    let locker_bank_details = { lockerBank };  
                    locker_bank_details.location = {};  
                    locker_bank_details.location.name = responseData.data.locker_bank_location;
                    locker_bank_details.name = responseData.data.locker_bank_name;
                    const isOpened = responseData?.data?.openstatus !== NOT_OPENED;
                    history.push({
                        pathname: getPathForNextPage(PARCEL_OWNER,DROP_PARCEL),
                        state: {
                            locker_bank_details: locker_bank_details,
                            locker_unit_details: responseData.data,
                            pickupUserDetails: pickupUserDetails,
                            clientRef: responseData.data.client_ref || null,
                            hasPendingLockers: null,
                            isOpened: isOpened,
                            status: PENDING,
                            ref_id: responseData.data?.transaction_id,
                            open_locker_by_scan_barcode:false,
                            assignTime:responseData.data.assignment_timestamp,
                        }
                    });
                }
            }
            catch(e)
            {
                console.error("error in locker open response")
            }
            setShowLoader(false);
        }
        else{
            history.push({
                pathname:getPathForNextPage(PARCEL_OWNER,LOCKER_UNIT_SELECTION),
                state: {
                    lockerBankId,
                    assignmentSlug,
                    pickupUserDetails,
                    selectedLockerSize: lockerItem,
                    userId:id,
                }
            })
        }
    }

    /**
     * Handles setting the mobile value and selected country length.
     * @param {string} value - The value of the input field.
     * @param {object} country - The selected country object.
     * @param {object} e - The event object.
     */
    const handleSetMobile = (value, country, e) => {
        const phoneNumber = e.target.value;
        if (phoneNumber) {
            setSelCountryLength(country.format.length);
            setMobile(phoneNumber);
            setCreateUserInput(phoneNumber);
            const isValidPhoneNumber = phoneNumber.length > 8 ? true : false;
            if (!isValidPhoneNumber) {
                setErrorMessage(t('errorLoginPhone'));
            } else {
                setErrorMessage('')
            }
            setDisabled(!isValidPhoneNumber);
            if(anonymous_user){
                setSearchValue(phoneNumber);
            }
        }
    };

    const handleSetEmail = (e) => {
        const value = e.target.value;
        setEmail(value);
        setCreateUserInput(value);
    };

    const showFiledType = () => {
        return anonymous_user ? 
        (
            <CustomSwitchInput
                isMobile={anonymous_user}
                mobile={anonymousUserFieldValue}
                email={email}
                handleSetMobile={handleSetMobile}
                handleSetEmail={handleSetEmail}
                error={!!errorMessage}
                hasSwitchedAuthMethod={hasSwitchedAuthMethod}
                disabled={disabled}
            />
        ) : 
        (
            <CustomTextInput
                placeholder={t('infoSearchUsers')}
                onChange={handleInputChange}
                type="text"
            />
        );
    }; 

    
    const handleCreateUser = async () => {
        setIsCreateUserModalVisible(false);
        const object = {};
        if (isMobileFieldVisible) {
            if(anonymous_user){
                object.mobile_number = createUserInput?.trim() || "";
            }else{
                object.mobile_number = mobile?.trim() || "";
            }
        }
        else {
            object.email = createUserInput?.trim() || "";    
        }
        try {
            const response = await CreateParcelOwner(assignmentSlug, object);
            if (response?.message?.toLowerCase() === "success") {
                if(!anonymous_user){
                    ShowToast(t('infoUserCreated'), TOAST_SUCCESS);
                    setMobile("");
                    setEmail("");
                    setCreateUserInput("");
                    setIsMobileFieldVisible(true);    
                }
                if(anonymous_user){
                    handleAssignLockerToPickUpUser(response?.data)
                }
            }
            else {
                if(anonymous_user){
                    ShowToast(response?.message || t('errorInvalidData'), TOAST_ERROR);
                }else{
                    setMobile(createUserInput);
                    setDialogMessage(response?.message || t('errorInvalidData'));
                    setIsDialogVisible(true);
                }
            }
        } 
        catch (error) {
            console.error("Error creating user:", error);
            if(anonymous_user){
                ShowToast(t('errorInvalidData'), TOAST_ERROR);
            }else{
                setMobile(createUserInput);
                setDialogMessage(error?.response?.message || t('errorInvalidData'));
                setIsDialogVisible(true);
            }
        }
    };

    const ShowCreateUserModel = ()=>{
        if(! anonymous_user){
            if(isMobileFieldVisible){
                if(phonePrefix){
                    const newValue = phonePrefix + searchValue;
                    setMobile( newValue);
                    setCreateUserInput(newValue);
                }else{
                    setMobile("");
                    setCreateUserInput("");
                }
            }else{
                setEmail(searchValue);
                setCreateUserInput(searchValue);
            }
        }
        setIsCreateUserModalVisible(true);
    }
    const handleUserToRender = (user) => {
        if (user.is_active) {
            handleAssignLockerToPickUpUser(user);
        }else{
            setIsBlockedUser(true);
        }
    }

    const handleShowUserList = () => {
        if (anonymous_user) {
            return null;
        } else {
            return (
                <div className='users-list-container'>
                    <ul>
                        {users.length > 0 ? (
                            users.map((user, index) => (
                                <li key={index} onClick={() => handleUserToRender(user)}
                                className={`user-list-item ${!user.is_active ? "disabled-user" : ""}`}
                                >
                                <UserInfo user={user} />
                            </li>
                            ))
                        ) : (
                            ""
                        )}
                    </ul>
                </div>
            );
        }
    }
    const showCreateUserButton = ()=>{
        if(! anonymous_user){
            if(guest_allowed){
                return modelConfirmButtonText;
            }
        }else{
            return modelConfirmButtonText;
        }
    }

    return (
        <div className='parcel-owner-page'>
            <div className='main-container'>
                <div className='main'>
                    <div className='user-search-container'>      
                        {showFiledType()}
                        
                    </div>
                    <div className='search-button-container'>
                        <ButtonComponent  
                                title={t('button_search')} 
                                handleClick={handleSearchUser} 
                            />
                    </div>
                   {handleShowUserList()}
                </div>
                {showLoader && (<CircularProgressLoader message={loadingMessage} />)}
                <CustomDialog
                    dialogId='error-dialog'
                    dialogVisible={isDialogVisible}
                    dialogTitle={modelTitle}
                    dialogContentText={dialogMessage} 
                    buttonOneTitle={modelCancelButtonText}
                    buttonTwoTitle={showCreateUserButton()}
                    buttonProps={{ 
                        buttonOne: { type:  BUTTON_WARNING},                      
                        buttonTwo: { type:  BUTTON_PRIMARY}
                    }}
                    handleCancel={() => {
                        setIsDialogVisible(false);
                        
                    }}
                    handleAccept={() => {
                        setIsDialogVisible(false);
                        ShowCreateUserModel();
                        if(anonymous_user){
                            handleCreateUser();
                        }
                    }} 
                />
                {isCreateUserModalVisible && (
                        <CustomDialog
                            dialogId='create-user-dialog'
                            dialogVisible={isCreateUserModalVisible}
                            dialogTitle={t('button_create_user')}
                            dialogContentText={
                                <CustomSwitchInput
                                    isMobile={isMobileFieldVisible}
                                    mobile={mobile}
                                    email={email}
                                    handleSetMobile={handleSetMobile}
                                    handleSetEmail={handleSetEmail}
                                    error={!!errorMessage}
                                    hasSwitchedAuthMethod={hasSwitchedAuthMethod}
                                    disabled={disabled}
                                />
                            }
                            buttonOneTitle={t("button_cancel")}
                            buttonTwoTitle={t("button_create_user")}
                            buttonProps={{
                                buttonOne: { type: BUTTON_WARNING},
                                buttonTwo: { type: BUTTON_PRIMARY}
                            }}
                            handleCancel={() => 
                                {
                                    setIsCreateUserModalVisible(false)
                                    setMobile("");
                                    setCreateUserInput("");
                                    ShowToast(t("errorUserCreationFailed"), TOAST_WARN);
                                    setIsMobileFieldVisible(true);
                                    setIsEmailFieldVisible(false);
                                }
                            }
                            handleAccept={handleCreateUser}
                        />
                )}
                {isBlockedUser && (
                    <CustomDialog
                        dialogId='dialog-blocked-user'
                        dialogVisible={isBlockedUser}
                        dialogContentText={t('infoUserInactive')}
                        buttonOneTitle={t("button_ok")}
                        buttonProps={{ buttonOne: { type: BUTTON_WARNING }}}
                        handleCancel={() => setIsBlockedUser(false)}
                    />
                )}
            </div>
        </div>
    );
}
export default ParcelOwner;